<template>
  <router-link 
    class="navbar-brand" 
    to="/" 
    @click="$emit('close')"
  >
    <img 
      class="navbar-logo" 
      :class="{ 'scrolled': isScrolled }"
      src="@/assets/images/logo-transparent.png" 
      alt="App Scontrini Logo"
    />
  </router-link>
</template>

<script>
export default {
  name: 'NavBrand',
  props: {
    isScrolled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close']
}
</script>

<style scoped>
.navbar-brand {
  display: flex;
  align-items: center;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1001;
  position: relative;
}

.navbar-brand:hover {
  transform: scale(1.05);
}

.navbar-logo {
  height: 60px;
  width: auto;
  transition: height 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.navbar-logo.scrolled {
  height: 50px;
}
</style>

